import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const TabContainer = styled.div`
  position: sticky;
  top: 55px;
  z-index: 90;
  background-color: #fff;
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: flex-start;
  gap: 8px;
  border-bottom: 1px solid
    var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: #fff;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent; /* 트랙 투명 */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #bababa;
  }
`;

export const Tab = styled.div<{ $active?: boolean }>`
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  padding: 6px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid var(--Alias-Color-Text-White-Gray-LightGray-200, #f0f0f0);
  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */

  ${({ $active }) =>
    $active &&
    `
  background: var(--Alias-Color-Button-cta-light-background-Primary, #1E9B6B);
  font-weight: 700;
  color: var(--White, #FFF);
`}
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 24px 16px;
  background: #fff;
`;

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Title/S-18-Bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.18px;
`;
